interface DescriptionFieldsProps {
  readonly description: string;
  readonly onDescriptionChange: (value: string) => void;
  readonly notes: string;
  readonly onNotesChange: (value: string) => void;
}

export function DescriptionFields({
  description,
  onDescriptionChange,
  notes,
  onNotesChange,
}: DescriptionFieldsProps) {
  return (
    <>
      <div>
        <label className="block text-[10px] font-medium text-ink-faint uppercase tracking-wide mb-1">
          Description
        </label>
        <textarea
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Description détaillée..."
          rows={2}
          className="w-full px-2.5 py-1.5 text-xs bg-surface border border-border/60 rounded-md focus:outline-none focus:border-accent/60 resize-none placeholder:text-ink-faint/60"
        />
      </div>

      <div>
        <label className="block text-[10px] font-medium text-ink-faint uppercase tracking-wide mb-1">
          Notes
        </label>
        <textarea
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          placeholder="Notes complémentaires..."
          rows={2}
          className="w-full px-2.5 py-1.5 text-xs bg-surface border border-border/60 rounded-md focus:outline-none focus:border-accent/60 resize-none placeholder:text-ink-faint/60"
        />
      </div>
    </>
  );
}
